module.exports = __webpack_public_path__ + "static/media/Artikal6.01454fe5.png";